import { FetchRequestState, PaginationParams } from 'types'
import { Store } from 'redux'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { TodoClient } from 'api/clients/TodoClient'
import { upsertComments } from 'redux/actions/comments'
import { upsertTodos, deleteTodo } from 'redux/actions/todos'
import store from 'redux/store'

export const TodoService = {
  getArticleTodos: async (articleId: string): Promise<FetchRequestState> => {
    const res = await TodoClient.getTodos(articleId)
    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertTodos(res.data.todos))
      return FetchRequestState.Resolved
    } else {
      return FetchRequestState.Rejected
    }
  },

  indexComments: async (store: Store, todoId: number, options: PaginationParams = {}) => {
    const res = await TodoClient.indexComments(todoId, options)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertComments(res.data.comments))
    }

    return res
  },

  batchDelete: async (store: Store, uuids: string[] = [], ids: number[] = []) => {
    const res = await TodoClient.batchDelete(uuids, ids)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const deletedTodos = res.data.todos
      for (const deletedTodo of deletedTodos) {
        store.dispatch(deleteTodo(deletedTodo.id))
      }
    }
  },

  batchUndelete: async (store: Store, uuids: string[] = [], ids: number[] = []) => {
    const res = await TodoClient.batchUndelete(uuids, ids)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(upsertTodos(res.data.todos))
    }
  },
}
